/**
 * キャンペーンを変更する際は、以下の値を更新してください：
 * - enabled: デフォルト表示=false, キャンペーン表示=true
 * - backgroundImageUrl: 背景画像のパス
 * - imageUrl: キャンペーン画像のパス
 * - linkUrl: キャンペーンのリンク先URL
 * - subHeading: サブ見出し
 */
export const campaignConfig: {
  enabled: boolean;
  backgroundImageUrl: string;
  imageUrl: string;
  linkUrl: string;
  subHeading: string;
  asideMessage: string;
} = {
  enabled: true,
  backgroundImageUrl: "/images/bg_campaign.png",
  imageUrl: "/images/campaign.png",
  linkUrl: "https://for-school-event.studyplus.co.jp/studyplus-agenda-2026aw",
  subHeading: "いつもご利用いただきありがとうございます",
  asideMessage: "",
};
